import { useEffect } from 'react';
import { atom, useRecoilState } from 'recoil';
export { Beta } from '@/components/Beta';

const betaState = atom<boolean | null>({
    key: 'beta',
    default: localStorage?.getItem('beta') === 'true',
});

export const useBeta = (): [boolean, (beta: boolean) => void] => {
    const localStorage = window.localStorage;

    const [beta, setBeta] = useRecoilState(betaState);
    useEffect(() => {
        localStorage?.setItem('beta', beta ? 'true' : 'false');
    }, [localStorage, beta]);

    return [beta, setBeta];
};
